const state = {
    task: [],
    id: [],
    taskbyleadid: [],
    loading: false
};

export default state;